import type { ApiErrorBody, ApiResponse, ApiSuccess } from '../types/api/envelope';

/**
 * Normalize any API JSON payload into a consistent shape.
 */
export function normalizeApiResponse<T = unknown>(payload: unknown): ApiResponse<T> {
  if (
    payload &&
    typeof payload === 'object' &&
    Object.prototype.hasOwnProperty.call(payload, 'success') &&
    Object.prototype.hasOwnProperty.call(payload, 'message')
  ) {
    return payload as ApiResponse<T>;
  }

  return {
    success: true,
    message: 'OK',
    data: payload as T,
  } satisfies ApiSuccess<T>;
}

export function isApiError(payload: ApiResponse<unknown>): payload is ApiErrorBody {
  return payload.success === false;
}
